import { useState, useEffect } from 'react';
import { API_URL, ROUTES, STAFF_ROSTER_OPTION, STAFF_POSITION_OPTION } from '../../../constants';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import axios from 'axios';

export const initialValues = {

}

export function DetailsDialog(props) {
    const { open, entity, onClose, onSubmit, apiUrl, normalizeReceivedValues } = props;
    const [entityValues, setEntityValues] = useState();
    const [loaded, setLoaded] = useState(false);


    useEffect(() => {
        if (entity) {
            axios.get((apiUrl.getOne ? apiUrl.getOne : apiUrl) + '/' + entity.id).then((response) => {
                let data = response?.data;
                let entityValues = { ...initialValues, ...data };
                normalizeReceivedValues(entityValues);
                setEntityValues(entityValues);
            }).catch((error) => {
            }).finally(() => {
                setLoaded(true);
            });
        } else {
            setEntityValues(initialValues);
        }
    }, [entity]);

    return (

        <Dialog
            open={open}
            keepMounted
            maxWidth="lg"
            onClose={onClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{"更期詳細"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell style={{ width:200 }}>員工姓名</TableCell>
                                <TableCell style={{ width:300 }}>{entityValues?.staffUserRoster?.staffUser?.nameTc}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>相應更期</TableCell>
                                <TableCell>{STAFF_ROSTER_OPTION.find(elem => elem.value == entityValues?.staffUserRoster?.roster)?.label}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>相應職級</TableCell>
                                <TableCell>{STAFF_POSITION_OPTION.find(elem => elem.value == entityValues?.staffUserRoster?.position)?.label}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>工作時間</TableCell>
                                <TableCell>{entityValues?.startTime?.substring(0,5) + " - " + entityValues?.endTime?.substring(0,5)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>更表標籤</TableCell>
                                <TableCell>{entityValues?.tag}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>工作日子</TableCell>
                                <TableCell>{entityValues &&
                                    entityValues.rosterSessions &&
                                    entityValues.rosterSessions.length > 0 && (
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>日期</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {entityValues.rosterSessions.map(item => (
                                                    <TableRow hover key={item.id}>
                                                        <TableCell>{item.day}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="primary" variant="contained" onClick={onClose} >
                    關閉
                </Button>
            </DialogActions>
        </Dialog>
    );
}

